import { render, staticRenderFns } from "./educationAdminList.vue?vue&type=template&id=292b6704"
import script from "./educationAdminList.vue?vue&type=script&lang=js"
export * from "./educationAdminList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292b6704')) {
      api.createRecord('292b6704', component.options)
    } else {
      api.reload('292b6704', component.options)
    }
    module.hot.accept("./educationAdminList.vue?vue&type=template&id=292b6704", function () {
      api.rerender('292b6704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/educationAdminList.vue"
export default component.exports